import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import ProductItem from "./ProductItem";

const HomeProductsSection = () => {
  const { products, containFilters, errMsg, error, loading } = useSelector(
    (state) => state.product
  );

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-white to-pale-orange/20">
      <div className="lg:px-0 xl:px-3 lg:mx-20 xl:mx-28 2xl:mx-36 3xl:mx-auto max-w-3xl mx-auto lg:max-w-7xl px-5">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-very-dark-blue font-bold text-3xl sm:text-4xl lg:text-5xl mb-4">
            Featured Products
          </h2>
          <p className="text-dark-grayish-blue text-base sm:text-lg max-w-2xl mx-auto">
            Explore our handpicked selection of premium Ayurvedic medicines
          </p>
        </div>

        {/* Products Grid */}
        <div className="max-w-2xl mx-auto lg:max-w-7xl">
          {!error ? (
            <>
              {loading ? (
                <div className="my-20 mx-auto">
                  <Loading />
                </div>
              ) : (
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
                  {products.slice(0, 8).map((product, index) => (
                    <ProductItem
                      key={product._id}
                      product={product}
                      containFilter={containFilters[index]}
                    />
                  ))}
                </div>
              )}
            </>
          ) : (
            <>
              <p className="mt-20 text-center text-very-dark-blue text-lg">
                {errMsg}. Please reload the page
              </p>
            </>
          )}
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mt-12 lg:mt-16">
          <Link to="products">
            <button className="group relative px-8 py-4 bg-orange text-white text-base font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden">
              <span className="relative z-10 flex items-center gap-2">
                Explore All Products
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-orange to-orange/80 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeProductsSection;
